export enum Period {
  weekly = 'Week',
  monthly = 'Month',
  quarterly = 'Quarter',
  yearly = 'Year',
}
